const webinarsHeroSection = $('#hero-section');
const heroFinderSearch = webinarsHeroSection.find('.hero-search-parent');
const heroFinderDropdown = webinarsHeroSection.find('.hero-dropdown-parent');
const heroFinderDropdownDescription = webinarsHeroSection.find('.hero-dropdown-list-description');
const heroFinderList = webinarsHeroSection.find('.hero-dropdown-list');
const searchResultsParent = webinarsHeroSection.find('.search-result-list');
const searchResultsOverflows = webinarsHeroSection.find('.result-card-overflow');
const searchResults = webinarsHeroSection.find('.result-card-parent');
const searchInputParent = webinarsHeroSection.find('.hero-search-parent');
const searchInput = webinarsHeroSection.find('.hero-search-input');
const searchCloseBtn = webinarsHeroSection.find('.search-close-btn');
const dropdownTagsParent = heroFinderList.find('.hero-dropdown-item-parent');
const dropdownTags = $('.hero-dropdown-item');
const searchCheckboxes = $('.topic-input');
const heroBG = webinarsHeroSection.find('.hero-blur-bg');
const finderChilds = webinarsHeroSection.find('.react-element');
const calendarParent = $('#date #hero-dropdown-item-calendar');
const heroContributeCard = webinarsHeroSection.find('.contribute-card');
const heroContributeCardIcons = heroContributeCard.find('.contribute-link-icon');

const dropdownWidth = pxToVw(heroFinderSearch.outerWidth());
const dropdownGap = pxToVw(Number(heroFinderDropdown.css('gap').replace('px', '')));
const dropdownDescriptionWidth = pxToVw(heroFinderDropdownDescription.outerWidth());
const finderListGap = pxToVw(Number(heroFinderList.css('gap').replace('px', '')));
const finderListOffset = (100 - dropdownWidth) / 2 + dropdownGap + dropdownDescriptionWidth;

let fpInstance;
const searchData = {
  input: '',
  tags: [],
  date: '',
};
const tagsTLs = [];
let isFinderOpened = false;
let isResultOpened = false;
let lastActiveTag = undefined;
let ignoreCalendarChange;

let toggleResultTL, toggleFinderTL, toggleFinderAndResultTL;

const resultLenis = new Lenis({
  wrapper: searchResultsParent.get(0),
  autoRaf: true,
});
gsap.set(searchResults, { zIndex: (index) => 1000 - index });
gsap.set(searchResultsParent, { display: 'none' });

const setFilterScrollers = () => {
  const filterList = webinarsHeroSection.find('.hero-dropdown-item-topics-list ');
  filterList.each(function () {
    const filterLenis = new Lenis({
      wrapper: $(this).get(0),
      autoRaf: true,
    });
  });
};

const setCalendar = (toDate, rawDate) => {
  const showResultsBtnCount = calendarParent.find('.hero-dropdown-resul-count');
  const topperLabel = calendarParent.closest('.hero-dropdown-overflow').find('.hero-dropdown-item-label');
};

const addCalendar = () => {
  const showResultsBtnCount = calendarParent.find('.hero-dropdown-resul-count');
  const topperLabel = calendarParent.closest('.hero-dropdown-overflow').find('.hero-dropdown-item-label');
  fpInstance = flatpickr('#date-picker', {
    inline: true,
    appendTo: calendarParent.get(0),
    plugins: [
      new monthSelectPlugin({
        shorthand: true,
        dateFormat: 'm-Y',
        altFormat: 'F Y',
        theme: 'dark',
      }),
    ],
    onChange: function (selectedDates, dateStr, instance) {
      if (ignoreCalendarChange) return;
      if (searchData.date === dateStr) {
        if (dateStr == '') {
          currentMonth = $(instance.innerContainer).find('.flatpickr-monthSelect-month.selected');
          currentMonth.toggleClass('selected');
        }
        searchData.date = '';
        ignoreCalendarChange = true;
        instance.clear();
        instance.redraw();
        ignoreCalendarChange = false;
        topperLabel.text('Date');
      } else {
        searchData.date = dateStr;
        const monthAbbr = instance.formatDate(selectedDates[0], 'M');
        topperLabel.text(monthAbbr);
      }
      count = sortResults();
      showResultsBtnCount.text(count);
    },
  });
  const prevIcon = $('.flatpickr-prev-month svg');
  const nextIcon = $('.flatpickr-next-month svg');
  prevIcon.replaceWith(
    `<img class='flatpickr-prev-icon' src='${calendarParent.attr('data-icon-src')}' style="transform: rotate(180deg)">`
  );
  nextIcon.replaceWith(`<img class='flatpickr-prev-icon' src='${calendarParent.attr('data-icon-src')}'>`);
};
addCalendar();

const getActiveResults = () => {
  const activeResults = [];
  searchResultsOverflows.each(function () {
    if ($(this).css('display') != 'none') {
      activeResults.push($(this));
    }
  });
  return activeResults;
};

const resultScroller = () => {
  searchResultsOverflows.each(function (index) {
    const resultCard = $(this).find('.result-card-parent');
    const resultTop = pxToVw($(this).position().top);
    const k = isDesktop() ? 12 : isTablet() ? 25 : 53;
    let opacity = Math.max(0, 1 - resultTop / k);
    if (resultTop < 0) {
      opacity = 1 - Math.min(5, Math.abs(resultTop)) / 5;
      gsap.set(resultCard, {
        y: `${Math.abs(resultTop)}vw`,
        scale: Math.max(0.3, opacity),
        filter: `blur(${(1 - opacity) * 20}px)`,
      });
    } else {
      gsap.set(resultCard, {
        y: 0,
        scale: 1,
        filter: 'blur(0px)',
      });
    }
    gsap.set($(this), { opacity: opacity });
  });
};

resultLenis.on('scroll', (e) => {
  ScrollTrigger.update();
  resultScroller();
});

const tagCloseIconAnimation = (closeIcon) => {
  const closeIconTL = gsap.timeline({ paused: true });
  closeIconTL.add(
    gsap.fromTo(
      closeIcon,
      {
        x: '3.125vw',
      },
      {
        x: 0,
        duration: 0.6,
        ease: 'tagInEasing',
      }
    ),
    0
  );
  closeIconTL.add(
    gsap.fromTo(
      closeIcon,
      {
        rotate: 0,
      },
      {
        rotate: -45,
        duration: 0.36,
        ease: 'tagInEasing',
      }
    ),
    0.14
  );
  closeIconTL.add(
    gsap.fromTo(
      closeIcon,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.36,
        ease: 'opacityInEasing',
      }
    ),
    0.24
  );

  return closeIconTL;
};

const tagContentAnimation = (content) => {
  if (content.attr('id') == 'hero-dropdown-item-calendar') {
    content = content.find('.flatpickr-innerContainer, .hero-dropdown-item-controls');
  }
  CustomEase.create('tagContentEasing', '0.2, 0, 0.2, 1');
  const contentTL = gsap.timeline({ paused: true });
  contentTL.add(
    gsap.fromTo(
      content,
      {
        y: '-1.875vw',
      },
      {
        y: 0,
        duration: 0.67,
        ease: 'tagContentEasing',
      }
    ),
    0
  );
  contentTL.add(
    gsap.fromTo(
      content,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.67,
        ease: 'opacityInEasing',
      }
    ),
    0
  );

  return contentTL;
};

const tagLineAniamtion = (line) => {
  const lineTL = gsap.timeline({ paused: true });
  lineTL.add(
    gsap.fromTo(
      line,
      {
        transformOrigin: 'center center',
        scaleX: 0,
      },
      {
        scaleX: 1,
        duration: 0.67,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  return lineTL;
};

const tagDateAnimtion = (tag) => {
  const dropdownLabel = tag.find('.hero-dropdown-item-label');
  const dropdownCurrentYear = tag.find('.cur-year');
  const dropdownYearNavPrev = tag.find('.flatpickr-prev-month');
  const dropdownYearNavNext = tag.find('.flatpickr-next-month');

  const dateTL = gsap.timeline({ paused: true });
  dateTL.add(
    gsap.fromTo(
      dropdownLabel,
      {
        opacity: 1,
      },
      {
        opacity: 0,
        duration: 0.27,
      }
    ),
    0
  );
  dateTL.add(
    gsap.fromTo(
      dropdownCurrentYear,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.27,
        onStart: () => {
          dropdownCurrentYear.css('display', 'block');
        },
        onReverseComplete: () => {
          dropdownCurrentYear.css('display', 'none');
        },
      }
    ),
    0.16
  );
  dateTL.add(
    gsap.fromTo(
      [dropdownYearNavPrev, dropdownYearNavNext],
      {
        x: (index) => `${(1 - index * 2) * 1.25}vw`,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
        duration: 0.72,
        ease: 'tagInEasing',
      }
    ),
    0.14
  );
  dateTL.add(
    gsap.fromTo(
      [dropdownYearNavPrev, dropdownYearNavNext],
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.48,
        ease: 'opacityInEasing',
      }
    ),
    0.39
  );

  return dateTL;
};

const toggleTag = (index) => {
  const currentTag = dropdownTags.eq(index);
  const dropdownTagParent = currentTag.closest('.hero-dropdown-item-parent');
  const tagOverflow = currentTag.closest('.hero-dropdown-overflow');
  const tagContent = currentTag.find('.hero-dropdown-item-content');
  const dropdownClosedTopper = currentTag.find('.hero-dropdown-item-topper-closed');
  const dropdownLine = currentTag.find('.hero-dropdown-item-topper-line');
  const dropdownOpenIcon = currentTag.find('.hero-dropdown-item-icon');
  const dropdownCloseIcon = currentTag.find('.hero-dropdown-close');

  const fromWidth = pxToVw(dropdownClosedTopper.outerWidth());
  const fromHeight = pxToVw(dropdownClosedTopper.outerHeight());
  const toWidth = pxToVw(currentTag.outerWidth());
  const toHeight = pxToVw(currentTag.outerHeight());
  const marginTo = isDesktop() ? 0 : isTablet() ? 0 : 8.333;
  const padddingFrom = {
    top: pxToVw(6),
    right: pxToVw(10),
    bottom: pxToVw(6),
    left: pxToVw(10),
  };
  const paddingTo = {
    top: pxToVw(10),
    right: pxToVw(10),
    bottom: pxToVw(10),
    left: pxToVw(20),
  };
  const toggleTagTL = gsap.timeline({
    paused: true,
    onStart: () => {
      gsap.set(dropdownCloseIcon, { display: 'block' });
    },
    onComplete: () => {},
    onReverseComplete: () => {
      gsap.set(dropdownCloseIcon, { display: 'none' });
    },
  });
  if (!isDesktop() && !isTablet()) {
    let offset = finderListOffset;
    dropdownTagsParent.each(function (elIndex) {
      if (elIndex >= index) return;
      offset += pxToVw($(this).outerWidth()) + finderListGap;
    });
    const widthDiff = (toWidth - fromWidth) / 2;
    const toOffset = -(offset - widthDiff - marginTo);
    toggleTagTL.add(
      gsap.fromTo(
        heroFinderDropdown,
        {
          x: 0,
        },
        {
          x: `${toOffset}vw`,
          duration: 0.67,
          ease: 'pageInEasing',
        }
      ),
      0
    );
  }
  toggleTagTL.add(
    gsap.fromTo(
      tagOverflow,
      {
        width: `${fromWidth}vw`,
        height: `${fromHeight}vw`,
        padding: `${padddingFrom.top}vw ${padddingFrom.right}vw ${padddingFrom.bottom}vw ${padddingFrom.left}vw`,
        marginInline: 0,
      },
      {
        width: `${toWidth}vw`,
        height: `${toHeight}vw`,
        padding: `${marginTo.top}vw ${marginTo.right}vw ${marginTo.bottom}vw ${marginTo.left}vw`,
        marginInline: `${marginTo}vw`,
        duration: 0.67,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  //start 8.33
  toggleTagTL.add(tagCloseIconAnimation(dropdownCloseIcon).play(), 0.07);
  toggleTagTL.add(tagContentAnimation(tagContent).play(), 0);
  toggleTagTL.add(tagLineAniamtion(dropdownLine).play(), 0);
  toggleTagTL.add(
    gsap.fromTo(
      dropdownOpenIcon,
      {
        opacity: 1,
      },
      {
        opacity: 0,
        duration: 0.27,
        ease: 'opacityInEasing',
      }
    ),
    0
  );
  if (currentTag.attr('id') == 'date') {
    toggleTagTL.add(tagDateAnimtion(currentTag).play(), 0);
  }
  return toggleTagTL;
};

const toggleResults = (direction) => {
  CustomEase.create('resultsEase', '0.5, 0.0, 0.8, 1.0');
  const resultOffset = isDesktop() ? 5.625 : isTablet() ? 5 : 80;
  const resultDuration = isDesktop() ? 0.42 : isTablet() ? 0.52 : 0.52;
  const toggleResultTL = gsap.timeline({
    paused: true,
    onStart: () => {
      resultScroller();
      gsap.set(searchResultsParent, { display: 'flex' });
    },
    onReverseComplete: () => {
      gsap.set(searchResultsParent, { display: 'none' });
    },
  });

  toggleResultTL.add(
    gsap.fromTo(
      searchResultsParent,
      {
        y: `${resultOffset}vw`,
      },
      {
        y: 0,
        duration: resultDuration,
        ease: 'resultsEase',
      }
    ),
    0
  );
  toggleResultTL.add(
    gsap.fromTo(
      searchResultsParent,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: resultDuration - 0.1,
        ease: 'opacityInEasing',
      }
    ),
    0.1
  );

  return toggleResultTL;
};

const toggleFinder = () => {
  const toggleFinderTL = gsap.timeline({
    paused: true,
    onStart: () => {
      headerAnimation(false, 0.4, 0.01).play();
      if (isDesktop()) {
        lenis.scrollTo(0, {
          lock: true,
          onComplete: () => {
            lenis.stop();
          },
        });
      }
    },
    onComplete: () => {
      heroBG.css('pointer-events', 'all');
    },
    onReverseComplete: () => {
      headerAnimation(true, 0.4, 0.01).play();
      heroBG.css('pointer-events', 'none');
      lenis.start();
      clearFinderOnEnd();
    },
  });
  const finderOffset = isDesktop() ? -3.75 : isTablet() ? -5 : -80;
  toggleFinderTL.add(
    gsap.fromTo(
      heroBG,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.67,
        ease: 'pageInEasing',
        overwrite: 'auto',
      }
    ),
    0
  );
  toggleFinderTL.add(
    gsap.fromTo(
      [heroFinderSearch, heroFinderDropdown],
      {
        y: 0,
      },
      {
        y: `${finderOffset}vw`,
        duration: 0.67,
        ease: 'pageInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0
  );
  toggleFinderTL.add(
    gsap.fromTo(
      searchCloseBtn,
      {
        y: '2.188vw',
        scale: 0,
      },
      {
        y: 0,
        scale: 1,
        duration: 0.67,
        ease: 'pageInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0
  );
  return toggleFinderTL;
};

function sortResults() {
  let activeCount = 0;
  searchResultsOverflows.each(function () {
    const dataset = this.dataset;
    const datasetValues = Object.values(dataset).map((v) => v.toLowerCase());
    const inputValue = searchData.input.toLowerCase();
    const tagValues = searchData.tags.map((tag) => tag.toLowerCase());
    const dateValue = searchData.date;

    const inputMatch = datasetValues.some((val) => val.includes(inputValue));
    const tagMatch = tagValues.every((tag) => datasetValues.some((val) => val.includes(tag)));
    const dateMatch = dateValue == '' || dateValue == dataset.date;

    if (inputMatch && tagMatch && dateMatch) {
      activeCount += 1;
      $(this).css('display', 'block');
    } else {
      $(this).css('display', 'none');
    }
  });
  return activeCount;
}

const clearFinderOnStart = () => {
  const checkboxCounter = webinarsHeroSection.find('.hero-dropdown-item-checked-count');
  searchInput.val('');
  searchCheckboxes.prop('checked', false);
  checkboxCounter.html('&#x24EA;');
  checkboxCounter.hide();
  searchData.input = '';
  searchData.tags = [];
};

const clearFinderOnEnd = () => {
  const resultCounter = webinarsHeroSection.find('.hero-dropdown-resul-count');
  count = sortResults();
  resultCounter.text(count);
  resultLenis.scrollTo(0);
};

const hostInAnimation = () => {
  const titleImagesParent = webinarsHeroSection.find('.hero-title-images');
  const imagesParentWidth = pxToVw(titleImagesParent.outerWidth());
  const titleImages = webinarsHeroSection.find('.hero-title:not(.hero-title-mobile) .title-image-parent');
  const titleImagesMobile = webinarsHeroSection.find('.hero-title-mobile .title-image-parent');
  const hostTL = gsap.timeline({ paused: true });
  const imageWidth = isDesktop() ? 3.5 : isTablet() ? 6.25 : 8.889;
  const imageOffset = isDesktop() ? 2.563 : isTablet() ? 4.776 : 6.389;

  hostTL.add(
    gsap.fromTo(
      titleImagesParent,
      {
        width: 0,
        marginRight: '-1.1vw',
      },
      {
        width: `${imagesParentWidth}vw`,
        marginRight: 0,
        duration: 1,
        ease: 'pageInEasing',
      }
    ),
    0
  );
  hostTL.add(
    gsap.fromTo(
      isDesktop() ? titleImages : titleImagesMobile,
      {
        scale: 0,
      },
      {
        transformOrigin: 'center bottom',
        scale: 1,
        duration: 1,
        ease: 'pageInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0
  );
  hostTL.add(
    gsap.fromTo(
      isDesktop() ? titleImages : titleImagesMobile,
      {
        x: (index) => `${index * imageWidth}vw`,
      },
      {
        x: (index) => `${index * imageOffset}vw`,
        duration: 0.67,
        ease: 'pageInEasing',
        stagger: {
          each: 0.1,
        },
      }
    ),
    0.16
  );
  hostTL.add(
    gsap.fromTo(
      isDesktop() ? titleImages : titleImagesMobile,
      {
        opacity: 0.4,
      },
      {
        opacity: 1,
        duration: 0.33,
        ease: 'opacityInEasing',
        stagger: {
          each: 0.03,
        },
      }
    ),
    0.33
  );

  return hostTL;
};

const changeChecked = (dropdownTag) => {
  const dropdownTagParent = dropdownTag.closest('.hero-dropdown-item-parent');
  const checkedCountContainer = dropdownTagParent.find('.hero-dropdown-item-checked-count');
  const checkedInputs = dropdownTagParent.find('.topic-input:checked');
  if (checkedCountContainer) {
    if (checkedInputs.length == 0) {
      checkedCountContainer.hide();
    } else {
      checkedCountContainer.show();
    }
    checkedCountContainer.html(`&#x${2460 + checkedInputs.length - 1}`);
  }
};

const addWebinarsHeroAnimation = () => {
  const heroDescription = webinarsHeroSection.find('.hero-description');
  const heroTitle = webinarsHeroSection.find('.hero-title');
  const heroDescriptorCard = webinarsHeroSection.find('.descriptor-card');

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
    },
  });

  heroTL.add(addBigTitleAnimation(heroTitle, 150, 0.9, 0.15).play(), 0.5);
  heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 0.5);
  heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 0.9);
  heroTL.add(elementInAnimationYWOpacity(heroFinderSearch, '8.75vw', 0, 1, 1, 0.8, 0.2).play(), 0.7);
  heroTL.add(elementInAnimationYWOpacity(heroFinderDropdown, '8.75vw', 0, 1, 1, 0.8, 0.2).play(), 0.8);
  heroTL.add(
    elementInAnimationYWOpacity(heroContributeCard, '13.75vw', 0, 1, 1, 0.63, 0.37, 0, 'start', 'inEasingcle').play(),
    1
  );
  heroTL.add(hostInAnimation().play(), 1.5);

  heroTL.add(() => {
    if (!isFinderOpened) {
      headerAnimation(true, 0.6, 0.01).play();
    }
  }, 1.9);

  return heroTL;
};

const initWebinarsHero = () => {
  setFilterScrollers();

  toggleResultTL = toggleResults();
  toggleFinderTL = toggleFinder();

  $(window).on('deviceChange', function () {
    if (toggleResultTL) toggleResultTL.kill();
    if (toggleFinderTL) toggleFinderTL.kill();
    tagsTLs.forEach((tl) => {
      if (tl && tl.kill) tl.kill();
    });

    tagsTLs.length = 0;

    dropdownTags.each(function (index) {
      const newTL = toggleTag(index);
      tagsTLs.push(newTL);
    });
    toggleResultTL = toggleResults();
    toggleFinderTL = toggleFinder();
  });

  heroBG.on('click', () => {
    let delay = 0;
    /*
    if (isFinderOpened && isResultOpened) {
    } else if (isFinderOpened && lastActiveTag != undefined) {
    } else {
      gsap.delayedCall(delay, () => {
        toggleFinderTL.reverse();
      });
      isFinderOpened = !isFinderOpened;
      lenis.start();
    }
  */
  });

  searchInput.on('focus', () => {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
    });

    gsap.to(searchInputParent, { borderColor: 'rgba(255, 255, 255, 0.20)', duration: 0.67, ease: 'pageInEasing' });
    if (!isResultOpened) {
      if (!isFinderOpened) {
        toggleFinderTL.play();
        gsap.delayedCall(0.2, () => toggleResultTL.play());
        isFinderOpened = !isFinderOpened;
      } else if (!isResultOpened) {
        let delay;
        if (lastActiveTag != undefined) {
          tagsTLs[lastActiveTag].reverse();
          delay = tagsTLs[lastActiveTag].duration() / 2;
          lastActiveTag = undefined;
        }
        gsap.delayedCall(delay, () => toggleResultTL.play());
      }
      isResultOpened = !isResultOpened;
    }
  });

  searchInput.on('blur', () => {
    gsap.to(searchInputParent, { borderColor: 'transparent', duration: 0.67, ease: 'pageInEasing' });
  });

  dropdownTags.each(function (index) {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1, maximum-scale=1';
    document.head.appendChild(meta);

    const dropdownTag = $(this);
    const showResultsBtnCount = dropdownTag.find('.hero-dropdown-resul-count');
    const tagCheckboxes = dropdownTag.find('.topic-input');
    const closeBtn = dropdownTag.find('.hero-dropdown-close');
    const showResults = dropdownTag.find('.hero-dropdown-item-show');
    const clearAll = dropdownTag.find('.hero-dropdown-item-clear');
    tagsTLs.push(toggleTag(index));
    dropdownTag.on('click', (e) => {
      e.stopPropagation();
      let delay = 0;
      if (!isFinderOpened) {
        toggleFinderTL.play();
        delay = 0.2;
        isFinderOpened = !isFinderOpened;
      }
      if (lastActiveTag != index) {
        if (lastActiveTag != undefined) {
          tagsTLs[lastActiveTag].reverse();
        }
        if (isResultOpened) {
          toggleResultTL.reverse();
          delay = toggleResultTL.duration() / 1.7;
          isResultOpened = !isResultOpened;
        }
        gsap.delayedCall(delay, () => tagsTLs[index].play());
        lastActiveTag = index;
      }
    });
    closeBtn.on('click', (e) => {
      e.stopPropagation();
      tagsTLs[lastActiveTag].reverse();
      gsap.delayedCall(tagsTLs[lastActiveTag].duration() / 2, () => toggleResultTL.play());
      isResultOpened = !isResultOpened;
      if (searchInput.val() != '') {
      }
      lastActiveTag = undefined;
      changeChecked(dropdownTag);
    });
    showResults.on('click', (e) => {
      e.stopPropagation();
      tagsTLs[lastActiveTag].reverse();
      gsap.delayedCall(tagsTLs[lastActiveTag].duration() / 2, () => toggleResultTL.play());
      isResultOpened = !isResultOpened;
      lastActiveTag = undefined;
      changeChecked(dropdownTag);
    });
    clearAll.on('click', (e) => {
      if (tagCheckboxes.length != 0) {
        e.stopPropagation();
        tagCheckboxes.prop('checked', false);
        tagCheckboxes.each(function () {
          const inputVal = $(this).val();
          searchData.tags = searchData.tags.filter((tag) => tag !== inputVal);
        });
        const count = sortResults(true);
        showResultsBtnCount.text(count);
      } else {
        searchData.date = '';
        fpInstance.clear();
      }
    });
  });

  searchCloseBtn.on('click', () => {
    let delay = 0;
    if (isFinderOpened) {
      clearFinderOnStart();
      if (isResultOpened) {
        gsap.delayedCall(0.1, () => toggleResultTL.reverse());
        delay = 0; //toggleResultTL.duration() / 3;
        isResultOpened = !isResultOpened;
      } else if (lastActiveTag != undefined) {
        tagsTLs[lastActiveTag].reverse();
        delay = 0.2; //tagsTLs[lastActiveTag].duration() / 2;
        lastActiveTag = undefined;
      }
      gsap.delayedCall(delay, () => toggleFinderTL.reverse());
      isFinderOpened = !isFinderOpened;
    }
  });

  if (isDesktop()) {
    searchCloseBtn.on('mouseenter', function () {
      gsap.to($(this), {
        rotate: '180deg',
        duration: 0.667,
        ease: 'pageInEasing',
        overwrite: 'auto',
      });
    });

    searchCloseBtn.on('mouseleave', function () {
      gsap.to($(this), {
        rotate: '0',
        duration: 0.667,
        ease: 'pageInEasing',
        overwrite: 'auto',
      });
    });
  }

  heroContributeCard.on('mouseenter', () => {
    arrowAnimation(heroContributeCardIcons, 1, 1);
  });

  heroContributeCard.on('mouseleave', () => {
    arrowAnimation(heroContributeCardIcons, 1, 0);
  });

  /* Input controls */
  searchInput.on('input', function () {
    searchData.input = $(this).val();
    sortResults(false);
    resultScroller();
  });

  searchCheckboxes.on('change', function () {
    const tagOverflow = $(this).closest('.hero-dropdown-overflow');
    const showResultsBtnCount = tagOverflow.find('.hero-dropdown-resul-count');
    const inputVal = $(this).val();
    if ($(this).prop('checked')) {
      searchData.tags.push(inputVal);
    } else {
      searchData.tags = searchData.tags.filter((tag) => tag !== inputVal);
    }
    const count = sortResults();
    resultScroller();
    showResultsBtnCount.text(count);
  });

  searchResults.each(function () {
    const resultIcon = $(this).find('.result-card-icon');
    $(this).on('mouseenter', () => {
      arrowAnimation(resultIcon, 1, 1);
    });
    $(this).on('mouseleave', () => {
      arrowAnimation(resultIcon, 1, 0);
    });
  });

  resultScroller();
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  initWebinarsHero();
  const webinarsHeroTL = addWebinarsHeroAnimation();
  pageIn(webinarsHeroTL, nav);
  if(window.location.href.includes('en-international')){
    initRegionChange('us', window.location.href);
  }
});
